// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.crypto-message-bar {
  display: grid;
  background: #ffffff;
  border: 0.1vw solid #1a6a7c;
  border-radius: 1.5vw;
  text-align: center;
  place-items: center;
  height: 2.2vw;
  padding: 0.1vw;
  margin: 0.1vw;
  color: #1a6a7c;
  font-size: 1.5vw;
}

.crypto-top-bar {
  display: grid;
  align-items: center;
  grid-template-columns: min-content auto 2.2vw;
  gap: 0.4vw;
}

a.crypto-logo {
  height: 2.2vw;
  margin-left: 4vw;
  margin-right: 4vw;
}

img.crypto-logo {
  position: relative;
  bottom: 2.4vw;
  height: 6vw;
}
.crypto-icon {
  cursor: pointer;
  height: 100%;
  width: 2.2vw;
}
.crypto-icon:active {
  filter: brightness(0.8);
}

/* .crypto-subtitle {
  display: grid;
  margin-left: 4.5vw;
  font-size: 2vw;
  margin-bottom: 0;
  margin-top: 0;
  line-height: 1;
} */
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/Сrypto/styles/CryptoTopBar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6CAA6C;EAC7C,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;AACA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;;AAEA;;;;;;;GAOG","sourcesContent":[".crypto-message-bar {\n  display: grid;\n  background: #ffffff;\n  border: 0.1vw solid #1a6a7c;\n  border-radius: 1.5vw;\n  text-align: center;\n  place-items: center;\n  height: 2.2vw;\n  padding: 0.1vw;\n  margin: 0.1vw;\n  color: #1a6a7c;\n  font-size: 1.5vw;\n}\n\n.crypto-top-bar {\n  display: grid;\n  align-items: center;\n  grid-template-columns: min-content auto 2.2vw;\n  gap: 0.4vw;\n}\n\na.crypto-logo {\n  height: 2.2vw;\n  margin-left: 4vw;\n  margin-right: 4vw;\n}\n\nimg.crypto-logo {\n  position: relative;\n  bottom: 2.4vw;\n  height: 6vw;\n}\n.crypto-icon {\n  cursor: pointer;\n  height: 100%;\n  width: 2.2vw;\n}\n.crypto-icon:active {\n  filter: brightness(0.8);\n}\n\n/* .crypto-subtitle {\n  display: grid;\n  margin-left: 4.5vw;\n  font-size: 2vw;\n  margin-bottom: 0;\n  margin-top: 0;\n  line-height: 1;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
